import BaseListagem from "components/BaseListagem";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterApplyTemplateOptions, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import FamiliaProdutoService from "service/administracao/cadastro/produto/FamiliaProdutoService";
import { IdMatchModeOptions, TextMatchModeOptions } from "utils/filterUtils";

const familiaService = new FamiliaProdutoService();

export default function FamiliaProdutoListagem() {

    const [origens, setOrigens] = useState<OrigemProduto[]>([]);

    useEffect(() => {
        familiaService.origens().then(lista => {
            setOrigens(lista);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    const origemFilterField = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={origens} filter
            onChange={(e) => options.filterCallback(e.value)} 
            optionLabel="nome" optionValue="codigo" placeholder="Qualquer" className="p-column-filter" />
    }

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        codigo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        origemProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const filterApplyTemplate = (options: ColumnFilterApplyTemplateOptions) => {
        return <Button type="button" label="Aplicar" onClick={options.filterApplyCallback} ></Button>;
    };

    return (

        <BaseListagem ordenacao="id.codigo,ASC" service={familiaService} urlService="/familiaProduto" tituloPagina={'Famílias'} defaultFilters={defaultFilters} showClearFilterButton nome="familia">
            <Column field="codigo" header="Código" style={{ width: '10em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="origemProduto.nome" header="Origem" style={{ width: '15em' }} filter filterField="origemProduto" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={origemFilterField} />
        </BaseListagem>
    )
}
